import { JoinerMapper, JoinerTransformMapper } from 'src/app/domainObjects/transformers/joinerTransform';

export class JoinerMapperViewModel {
  nodeID:string;
  index: number;
  indexName: string;
  nodeColor:string;
  nodeFields:string;
  nodeName:string;
  nodeNo:string;
  nodeRows:string;
  nodeCoordinate:string;
  mapTable:JoinerMapper[];

    constructor(mapper: JoinerTransformMapper) {
      this.nodeID = mapper.nodeID;
      this.index = mapper.index;
      this.indexName = mapper.indexName;
      this.nodeColor = mapper.nodeColor;
      this.nodeFields = mapper.nodeFields;
      this.nodeName = mapper.nodeName;
      this.nodeNo = mapper.nodeNo;
      this.nodeRows = mapper.nodeRows;
      this.nodeCoordinate = mapper.nodeCoordinate;
      this.mapTable=mapper.mapTable;
    }
  
    toJoinerMapper(): JoinerTransformMapper {
      const mapper = new JoinerTransformMapper();
      mapper.nodeID = this.nodeID;
      mapper.index = this.index;
      mapper.nodeColor = this.nodeColor;
      //mapper.nodeFields = this.nodeFields;
      mapper.nodeName = this.nodeName;
      //mapper.nodeNo = this.nodeNo;
      //mapper.nodeRows = this.nodeRows;
      mapper.nodeCoordinate=this.nodeCoordinate? this.nodeCoordinate:this.nodeNo;
      //mapper.mapTable=this.mapTable;
      mapper.mapTable = this.mapTable.filter(map=>map.mapTo);
      
      return mapper;
    }
  }

  
